export default "__VITE_ASSET__vArKTQ5p__"